exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BonusesBanner_banner_3Ett {\n  margin: 0 5px 10px;\n\n  display: block;\n\n  width: 100%;\n  height: 190px;\n\n  border: 1px solid #ceccca;\n  border-radius: 4px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n", ""]);

// exports
exports.locals = {
	"banner": "BonusesBanner_banner_3Ett"
};